/* TODO: Fix following eslint error */
/* eslint react/no-did-update-set-state: 0 */

import React from 'react'
import PropTypes from 'prop-types'
import Resx from '@/components/Resx'
import Icon from '@/components/Icon'
import Tooltip from './../Tooltip'
import { downloadFile } from '@/utils/downloader'

class FileItem extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
    readonly: PropTypes.bool,
    editable: PropTypes.bool,
    state: PropTypes.oneOfType([PropTypes.oneOf(['pending', 'existing']), PropTypes.number, PropTypes.string]),
    verified: PropTypes.bool,
    onRemove: PropTypes.func,
    isRemoveEnabled: PropTypes.bool,
    downloadAction: PropTypes.func,
    customActions: PropTypes.arrayOf(PropTypes.shape({
      buttonContent: PropTypes.object.isRequired,
      buttonProps: PropTypes.object,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool
    }))
    // onRename: PropTypes.func, Error: Unused propType
  }
  static defaultProps = {
    isRemoveEnabled: true
  }

  state = { name: '', downloadProgress: null }

  componentDidMount () {
    this.setState({ name: this.props.name })
  }

  componentDidUpdate (prevProps) {
    if (prevProps.name !== this.props.name) {
      this.setState({ name: this.props.name })
    }
  }

  onRemove = () => {
    const { id, onRemove, isRemoveEnabled } = this.props
    if (isRemoveEnabled) { onRemove(id) }
  }

  onNameChange = e => {
    this.setState({ name: e.target.value })
  }

  onDownloadComplete = (e) => {
    this.setState({ downloadProgress: null })
  }

  onDownloadClick = (e) => {
    downloadFile(this.props.id, this.props.downloadAction, this.onDownloadProgress, this.onDownloadComplete)
  }

  onDownloadProgress = e => {
    if (e.lengthComputable) {
      this.setState({ downloadProgress: Math.round((e.loaded / e.total) * 100) })
    }
  }

  onCustomAction = (action) => {
    const { id } = this.props
    if (typeof action.onClick === 'function') {
      action.onClick(id)
    }
  }

  render () {
    const { verified } = this.props
    let width = this.renderProgressBar()
    let className = verified ? 'file-attachment file-attachment--verified' : 'file-attachment'
    return (<li className={className}>
      {this.renderIcon()}
      <span className='file-name-size-wrapper'>
        {this.renderName()}
        {this.renderSize()}
      </span>
      <strong className='upload-status'>
        {this.renderStatus()}
        {this.renderDownloadButton()}
        {this.renderDeleteButton()}
        {this.renderCustomActionButtons()}
      </strong>
      <span className='file-progress-bar' style={{ width: width }} />
    </li>)
  }

  renderIcon () {
    const { name } = this.state
    const ext = getFileExtension(name)
    return (
      <Icon name={getIconClass(ext)} />
    )
  }

  renderName () {
    const { name } = this.state
    const { editable } = this.props
    return (
      <span className='file-name' title={name}>
        {editable
          ? <input type='text' value={name} onChange={this.onNameChange} />
          : name}
      </span>
    )
  }

  renderSize () {
    const { length } = this.props
    const fileSize = humanFileSize(length)
    return (
      <span className='file-attachment__size'>{fileSize.size} <span>{fileSize.unit}</span></span>
    )
  }

  renderProgressBar () {
    const { state } = this.props
    const { downloadProgress } = this.state
    if (typeof downloadProgress === 'number') {
      return `${downloadProgress}%`
    } else if (typeof state === 'number' && state < 100) {
      return `${state}%`
    }
    if (state === 'existing') {
      return '100%'
    }
  }

  getStatus () {
    const { state, verified } = this.props

    if (typeof state === 'number') {
      return { icon: 'bx-loader bx-spin' }
    } else if (typeof state === 'string') {
      switch (state) {
        case 'pending':
          return { icon: 'bx-loader bx-tada' }
        case 'existing': {
          if (typeof verified === 'boolean') {
            return verified
              ? {
                icon: 'check green',
                tooltip: 'Common.FileVerified'
              } : {
                icon: 'bug red',
                tooltip: 'Common.VirusDetected'
              }
          }
          return {
            icon: 'check',
            tooltip: 'Common.FileNotVerified'
          }
        }
        default: return {
          icon: 'bxs-error red',
          tooltip: state
        }
      }
    }
    return {}
  }

  renderStatus () {
    const { id } = this.props
    const status = this.getStatus()
    if (status.tooltip && status.icon) {
      return (
        <React.Fragment>
          <Tooltip placement='top' target={'file-attachment-icon-' + id}><Resx name={status.tooltip} /></Tooltip>
          <Icon id={'file-attachment-icon-' + id} name={status.icon} />
        </React.Fragment>
      )
    } else if (status.icon) {
      return <Icon name={status.icon} />
    }
    return null
  }

  renderDownloadButton () {
    const { verified, downloadAction } = this.props
    if (verified !== true || typeof downloadAction !== 'function') return null
    return (
      <button type='button' onClick={this.onDownloadClick}> <Icon name='download' /></button>
    )
  }

  renderDeleteButton () {
    const { readonly, isRemoveEnabled } = this.props
    if (readonly || !isRemoveEnabled) return null
    return (
      <button type='button' onClick={this.onRemove}> <Icon name='x' /></button>
    )
  }

  renderCustomActionButtons () {
    const { customActions, verified } = this.props
    if (!customActions || verified !== true) return null

    return customActions.map((action, index) =>
      <button key={index} type='button' {...action.buttonProps} disabled={action.disabled}
        onClick={() => this.onCustomAction(action)}> {action.buttonContent}</button>)
  }
}

function getIconClass (extension) {
  switch (extension) {
    case '.pdf':
    case '.doc':
    case '.docx':
      return 'file'
    case '.jpg':
    case '.jpeg':
    case '.png':
    case '.bmp':
    case '.tif':
      return 'file-image'
    case '.zip':
    case '.rar':
    case '.tar':
    case '.7z':
      return 'files'
    default: return 'file-blank'
  }
}

function getFileExtension (filename) {
  return (filename && filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2)) || ''
}

function humanFileSize (bytes) {
  const thresh = 1024
  if (Math.abs(bytes) < thresh) {
    return { size: bytes, unit: 'B' }
  }
  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  let u = -1
  do {
    bytes /= thresh
    ++u
  } while (Math.abs(bytes) >= thresh && u < units.length - 1)
  return { size: bytes.toFixed(1), unit: units[u] }
}

export {
  FileItem,
  humanFileSize
}



// WEBPACK FOOTER //
// ./src/components/fileAttachments/fileItem.js